var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('left',[_vm._t("left")],2),_c('div',{staticClass:"column right tiling-container"},[_c('div',{class:{ hide: _vm.$root.hidden || _vm.$root.hideNav }},[_vm._t("right")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }